import React from "react";
import { useNavigate } from "react-router-dom"; // Import Link or useNavigate
import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import "./styles.css";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { callUnsetApi } from "utils/api";

// Import state images
import karnatakaImg from "../../images/karnataka.jpg";
import maharashtraImg from "../../images/maharashtra.jpg";
import andhraImg from "../../images/andhra.jpg";
import assamImg from "../../images/assam.jpg";
import biharImg from "../../images/bihar.jpg";
import chhattisgarhImg from "../../images/chhattisgarh.jpg";
import gujaratImg from "../../images/gujarat.jpg";
import haryanaImg from "../../images/haryana.jpg";
import himachalImg from "../../images/himachal.jpg";
import jharkhandImg from "../../images/jharkhand.jpg";
import jnkImg from "../../images/jnk.jpg";
import keralaImg from "../../images/kerala.jpg";
import madhyaImg from "../../images/madhya.jpg";
import odishaImg from "../../images/odisha.png";
import punjabImg from "../../images/punjab.jpg";
import andamanImg from "../../images/andaman.png";

// Map state names to their images
const stateImageMap = {
  Karnataka: karnatakaImg,
  Maharashtra: maharashtraImg,
  "Andhra Pradesh": andhraImg,
  Assam: assamImg,
  Bihar: biharImg,
  Chhattisgarh: chhattisgarhImg,
  Gujarat: gujaratImg,
  Haryana: haryanaImg,
  "Himachal Pradesh": himachalImg,
  Jharkhand: jharkhandImg,
  "Jammu and Kashmir": jnkImg,
  "J&K": jnkImg,
  Kerala: keralaImg,
  "Madhya Pradesh": madhyaImg,
  Odisha: odishaImg,
  Punjab: punjabImg,
  "Andaman and Nicobar": andamanImg,
  Andaman: andamanImg,
};
const Dashboard = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [circles, setCircles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const siteId = sessionStorage.getItem("selectedSiteId");
  // console.log(siteId);
  useEffect(() => {
    if (siteId) {
      callUnsetApi(siteId);
      callUnsetApi(siteId);
    }
  }, [siteId]); // Runs when siteId changes (including on page load)

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userDetails");
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      setUserDetails(parsedData);
    }
  }, []);

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/dashboard");
    }
  }, [navigate]);

  useEffect(() => {
    if (userDetails) {
      const fetchCirclesData = async () => {
        try {
          const url = `https://api.bharatnet.sunshineiotronics.com/api/v2/configuration/circles/${encodeURIComponent(
            userDetails.email
          )}`;
          const response = await fetch(url);
          console.log(response);
          const data = await response.json();
          console.log(data);

          // Transform array of strings to array of objects with state and image_url
          const transformedData = Array.isArray(data)
            ? data.map((stateName) => {
                // Get image from mapping, fallback to a default image if not found
                const imageUrl = stateImageMap[stateName] || karnatakaImg; // Default fallback

                return {
                  state: stateName,
                  image_url: imageUrl,
                };
              })
            : [];

          setCircles(transformedData);
        } catch (error) {
          console.error("Error fetching circles data:", error);
        }
      };

      fetchCirclesData();
    }
  }, [userDetails]);

  const breadcrumbs = [
    <Link></Link>,
    <Typography key="3" sx={{ color: "text.primary" }}>
      Dashboard
    </Typography>,
  ];

  const filteredCircles = circles.filter(
    (circle) =>
      circle?.state &&
      circle.state.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box m="1.5rem 2.5rem">
      <div className="container-fluid page-body-wrapper">
        <br />
        <br />
        <div className="main-panel">
          <div className="content-wrapper">
            <Stack spacing={2}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="medium" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Stack>

            {/* Search Bar */}
            <div className="search-bar-container">
              <input
                type="text"
                id="searchBar"
                placeholder="Search States..."
                value={searchTerm}
                autoComplete="off"
                className="search-bar"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Card Container */}
            <div className="card-container">
              {filteredCircles.map((circle, index) => (
                <div
                  className="card"
                  key={index}
                  onClick={() => {
                    const stateName = circle.state;
                    sessionStorage.setItem("selectedState", stateName);
                    navigate(`/${stateName}/displaySite`);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={circle.image_url}
                    alt={circle.state}
                    className="card-image"
                  />
                  <h5 className="card-title">{circle.state}</h5>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default Dashboard;
